import React, { useEffect } from "react";
import { Typography } from "@mui/material";
import { getIpdLabTestStatus, isIpdResultEditable } from "../labTestWorkflowUtils";
import IpdTestResultsPanel from "./IpdTestResultsPanel";
import WorkflowPanelModal from "./WorkflowPanelModal";
import { IpdWorkflowDetails } from "./WorkflowPatientDetails";

const IpdWorkflowResultsModal = ({ open, onClose, group, onSubmitted, onSubmittingChange }) => {
  const focusTestId = group?._focusTestId;
  const editableTests = (group?.labTests || []).filter((test) => {
    if (!isIpdResultEditable(test)) return false;
    if (!focusTestId) return true;
    return Number(test.id) === Number(focusTestId);
  });

  useEffect(() => {
    if (open && group && editableTests.length === 0) {
      onClose && onClose();
    }
  }, [open, group, editableTests.length, onClose]);

  const handleSubmitted = async () => {
    if (onSubmitted) await onSubmitted();
  };

  const detailsGroup = editableTests.length ? { ...group, labTests: editableTests } : group;
  const modalTitle = editableTests.every(
    (test) => ["COMPLETED", "COMPLETE"].includes(getIpdLabTestStatus(test))
  )
    ? "Edit Results"
    : "Add Results";

  if (!group || !open) return null;

  return (
    <WorkflowPanelModal open={open} onClose={onClose} title={modalTitle} width={{ xs: "95%", sm: 680 }}>
      <IpdWorkflowDetails group={detailsGroup} />
      {editableTests.length > 0 ? (
        <IpdTestResultsPanel
          group={group}
          focusTestId={focusTestId}
          onSubmitted={handleSubmitted}
          onSubmittingChange={onSubmittingChange}
          embedded
        />
      ) : (
        <Typography variant="body2" color="text.secondary">
          No results available to edit.
        </Typography>
      )}
    </WorkflowPanelModal>
  );
};

export default IpdWorkflowResultsModal;
